import api from './interceptor';

const BASE_URL_V2 = 'api/v2/order-form';

export default {
  // API Version 2
  getOrderForm: appointmentId => api.get(`${BASE_URL_V2}/${appointmentId}`),
  postOrderForm: (appointmentId, params) => api.put(`${BASE_URL_V2}/${appointmentId}`, params),
};
